/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { apiProductsqueryRecommendationsLatestGet } from '../fn/recommendations/api-productsquery-recommendations-latest-get';
import { ApiProductsqueryRecommendationsLatestGet$Params } from '../fn/recommendations/api-productsquery-recommendations-latest-get';
import { apiProductsqueryRecommendationsLatestGet$Plain } from '../fn/recommendations/api-productsquery-recommendations-latest-get-plain';
import { ApiProductsqueryRecommendationsLatestGet$Plain$Params } from '../fn/recommendations/api-productsquery-recommendations-latest-get-plain';
import { apiProductsqueryRecommendationsLatestLabelGet } from '../fn/recommendations/api-productsquery-recommendations-latest-label-get';
import { ApiProductsqueryRecommendationsLatestLabelGet$Params } from '../fn/recommendations/api-productsquery-recommendations-latest-label-get';
import { apiProductsqueryRecommendationsLatestLabelGet$Plain } from '../fn/recommendations/api-productsquery-recommendations-latest-label-get-plain';
import { ApiProductsqueryRecommendationsLatestLabelGet$Plain$Params } from '../fn/recommendations/api-productsquery-recommendations-latest-label-get-plain';
import { apiProductsqueryRecommendationsNeighborsItemIdGet } from '../fn/recommendations/api-productsquery-recommendations-neighbors-item-id-get';
import { ApiProductsqueryRecommendationsNeighborsItemIdGet$Params } from '../fn/recommendations/api-productsquery-recommendations-neighbors-item-id-get';
import { apiProductsqueryRecommendationsNeighborsItemIdGet$Plain } from '../fn/recommendations/api-productsquery-recommendations-neighbors-item-id-get-plain';
import { ApiProductsqueryRecommendationsNeighborsItemIdGet$Plain$Params } from '../fn/recommendations/api-productsquery-recommendations-neighbors-item-id-get-plain';
import { apiProductsqueryRecommendationsPopularCategoriesGet } from '../fn/recommendations/api-productsquery-recommendations-popular-categories-get';
import { ApiProductsqueryRecommendationsPopularCategoriesGet$Params } from '../fn/recommendations/api-productsquery-recommendations-popular-categories-get';
import { apiProductsqueryRecommendationsPopularCategoriesGet$Plain } from '../fn/recommendations/api-productsquery-recommendations-popular-categories-get-plain';
import { ApiProductsqueryRecommendationsPopularCategoriesGet$Plain$Params } from '../fn/recommendations/api-productsquery-recommendations-popular-categories-get-plain';
import { apiProductsqueryRecommendationsPopularCategoriesIdGet } from '../fn/recommendations/api-productsquery-recommendations-popular-categories-id-get';
import { ApiProductsqueryRecommendationsPopularCategoriesIdGet$Params } from '../fn/recommendations/api-productsquery-recommendations-popular-categories-id-get';
import { apiProductsqueryRecommendationsPopularCategoriesIdGet$Plain } from '../fn/recommendations/api-productsquery-recommendations-popular-categories-id-get-plain';
import { ApiProductsqueryRecommendationsPopularCategoriesIdGet$Plain$Params } from '../fn/recommendations/api-productsquery-recommendations-popular-categories-id-get-plain';
import { apiProductsqueryRecommendationsPopularGet } from '../fn/recommendations/api-productsquery-recommendations-popular-get';
import { ApiProductsqueryRecommendationsPopularGet$Params } from '../fn/recommendations/api-productsquery-recommendations-popular-get';
import { apiProductsqueryRecommendationsPopularGet$Plain } from '../fn/recommendations/api-productsquery-recommendations-popular-get-plain';
import { ApiProductsqueryRecommendationsPopularGet$Plain$Params } from '../fn/recommendations/api-productsquery-recommendations-popular-get-plain';
import { apiProductsqueryRecommendationsPopularLabelsGet } from '../fn/recommendations/api-productsquery-recommendations-popular-labels-get';
import { ApiProductsqueryRecommendationsPopularLabelsGet$Params } from '../fn/recommendations/api-productsquery-recommendations-popular-labels-get';
import { apiProductsqueryRecommendationsPopularLabelsGet$Plain } from '../fn/recommendations/api-productsquery-recommendations-popular-labels-get-plain';
import { ApiProductsqueryRecommendationsPopularLabelsGet$Plain$Params } from '../fn/recommendations/api-productsquery-recommendations-popular-labels-get-plain';
import { apiProductsqueryRecommendationsRecommendUserIdGet } from '../fn/recommendations/api-productsquery-recommendations-recommend-user-id-get';
import { ApiProductsqueryRecommendationsRecommendUserIdGet$Params } from '../fn/recommendations/api-productsquery-recommendations-recommend-user-id-get';
import { apiProductsqueryRecommendationsRecommendUserIdGet$Plain } from '../fn/recommendations/api-productsquery-recommendations-recommend-user-id-get-plain';
import { ApiProductsqueryRecommendationsRecommendUserIdGet$Plain$Params } from '../fn/recommendations/api-productsquery-recommendations-recommend-user-id-get-plain';
import { SalesArticleSummary } from '../models/sales-article-summary';

@Injectable({ providedIn: 'root' })
export class RecommendationsService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiProductsqueryRecommendationsPopularGet()` */
  static readonly ApiProductsqueryRecommendationsPopularGetPath = '/api/productsquery/recommendations/popular';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProductsqueryRecommendationsPopularGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiProductsqueryRecommendationsPopularGet$Plain$Response(params?: ApiProductsqueryRecommendationsPopularGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<SalesArticleSummary>>> {
    return apiProductsqueryRecommendationsPopularGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProductsqueryRecommendationsPopularGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiProductsqueryRecommendationsPopularGet$Plain(params?: ApiProductsqueryRecommendationsPopularGet$Plain$Params, context?: HttpContext): Observable<Array<SalesArticleSummary>> {
    return this.apiProductsqueryRecommendationsPopularGet$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<SalesArticleSummary>>): Array<SalesArticleSummary> => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProductsqueryRecommendationsPopularGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiProductsqueryRecommendationsPopularGet$Response(params?: ApiProductsqueryRecommendationsPopularGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<SalesArticleSummary>>> {
    return apiProductsqueryRecommendationsPopularGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProductsqueryRecommendationsPopularGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiProductsqueryRecommendationsPopularGet(params?: ApiProductsqueryRecommendationsPopularGet$Params, context?: HttpContext): Observable<Array<SalesArticleSummary>> {
    return this.apiProductsqueryRecommendationsPopularGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<SalesArticleSummary>>): Array<SalesArticleSummary> => r.body)
    );
  }

  /** Path part for operation `apiProductsqueryRecommendationsPopularLabelsGet()` */
  static readonly ApiProductsqueryRecommendationsPopularLabelsGetPath = '/api/productsquery/recommendations/popular/{labels}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProductsqueryRecommendationsPopularLabelsGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiProductsqueryRecommendationsPopularLabelsGet$Plain$Response(params: ApiProductsqueryRecommendationsPopularLabelsGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<{
[key: string]: Array<SalesArticleSummary>;
}>> {
    return apiProductsqueryRecommendationsPopularLabelsGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProductsqueryRecommendationsPopularLabelsGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiProductsqueryRecommendationsPopularLabelsGet$Plain(params: ApiProductsqueryRecommendationsPopularLabelsGet$Plain$Params, context?: HttpContext): Observable<{
[key: string]: Array<SalesArticleSummary>;
}> {
    return this.apiProductsqueryRecommendationsPopularLabelsGet$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<{
[key: string]: Array<SalesArticleSummary>;
}>): {
[key: string]: Array<SalesArticleSummary>;
} => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProductsqueryRecommendationsPopularLabelsGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiProductsqueryRecommendationsPopularLabelsGet$Response(params: ApiProductsqueryRecommendationsPopularLabelsGet$Params, context?: HttpContext): Observable<StrictHttpResponse<{
[key: string]: Array<SalesArticleSummary>;
}>> {
    return apiProductsqueryRecommendationsPopularLabelsGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProductsqueryRecommendationsPopularLabelsGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiProductsqueryRecommendationsPopularLabelsGet(params: ApiProductsqueryRecommendationsPopularLabelsGet$Params, context?: HttpContext): Observable<{
[key: string]: Array<SalesArticleSummary>;
}> {
    return this.apiProductsqueryRecommendationsPopularLabelsGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<{
[key: string]: Array<SalesArticleSummary>;
}>): {
[key: string]: Array<SalesArticleSummary>;
} => r.body)
    );
  }

  /** Path part for operation `apiProductsqueryRecommendationsPopularCategoriesGet()` */
  static readonly ApiProductsqueryRecommendationsPopularCategoriesGetPath = '/api/productsquery/recommendations/popular/categories';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProductsqueryRecommendationsPopularCategoriesGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiProductsqueryRecommendationsPopularCategoriesGet$Plain$Response(params?: ApiProductsqueryRecommendationsPopularCategoriesGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<{
[key: string]: Array<SalesArticleSummary>;
}>> {
    return apiProductsqueryRecommendationsPopularCategoriesGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProductsqueryRecommendationsPopularCategoriesGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiProductsqueryRecommendationsPopularCategoriesGet$Plain(params?: ApiProductsqueryRecommendationsPopularCategoriesGet$Plain$Params, context?: HttpContext): Observable<{
[key: string]: Array<SalesArticleSummary>;
}> {
    return this.apiProductsqueryRecommendationsPopularCategoriesGet$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<{
[key: string]: Array<SalesArticleSummary>;
}>): {
[key: string]: Array<SalesArticleSummary>;
} => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProductsqueryRecommendationsPopularCategoriesGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiProductsqueryRecommendationsPopularCategoriesGet$Response(params?: ApiProductsqueryRecommendationsPopularCategoriesGet$Params, context?: HttpContext): Observable<StrictHttpResponse<{
[key: string]: Array<SalesArticleSummary>;
}>> {
    return apiProductsqueryRecommendationsPopularCategoriesGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProductsqueryRecommendationsPopularCategoriesGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiProductsqueryRecommendationsPopularCategoriesGet(params?: ApiProductsqueryRecommendationsPopularCategoriesGet$Params, context?: HttpContext): Observable<{
[key: string]: Array<SalesArticleSummary>;
}> {
    return this.apiProductsqueryRecommendationsPopularCategoriesGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<{
[key: string]: Array<SalesArticleSummary>;
}>): {
[key: string]: Array<SalesArticleSummary>;
} => r.body)
    );
  }

  /** Path part for operation `apiProductsqueryRecommendationsPopularCategoriesIdGet()` */
  static readonly ApiProductsqueryRecommendationsPopularCategoriesIdGetPath = '/api/productsquery/recommendations/popular/categories/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProductsqueryRecommendationsPopularCategoriesIdGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiProductsqueryRecommendationsPopularCategoriesIdGet$Plain$Response(params: ApiProductsqueryRecommendationsPopularCategoriesIdGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<SalesArticleSummary>>> {
    return apiProductsqueryRecommendationsPopularCategoriesIdGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProductsqueryRecommendationsPopularCategoriesIdGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiProductsqueryRecommendationsPopularCategoriesIdGet$Plain(params: ApiProductsqueryRecommendationsPopularCategoriesIdGet$Plain$Params, context?: HttpContext): Observable<Array<SalesArticleSummary>> {
    return this.apiProductsqueryRecommendationsPopularCategoriesIdGet$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<SalesArticleSummary>>): Array<SalesArticleSummary> => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProductsqueryRecommendationsPopularCategoriesIdGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiProductsqueryRecommendationsPopularCategoriesIdGet$Response(params: ApiProductsqueryRecommendationsPopularCategoriesIdGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<SalesArticleSummary>>> {
    return apiProductsqueryRecommendationsPopularCategoriesIdGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProductsqueryRecommendationsPopularCategoriesIdGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiProductsqueryRecommendationsPopularCategoriesIdGet(params: ApiProductsqueryRecommendationsPopularCategoriesIdGet$Params, context?: HttpContext): Observable<Array<SalesArticleSummary>> {
    return this.apiProductsqueryRecommendationsPopularCategoriesIdGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<SalesArticleSummary>>): Array<SalesArticleSummary> => r.body)
    );
  }

  /** Path part for operation `apiProductsqueryRecommendationsLatestGet()` */
  static readonly ApiProductsqueryRecommendationsLatestGetPath = '/api/productsquery/recommendations/latest';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProductsqueryRecommendationsLatestGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiProductsqueryRecommendationsLatestGet$Plain$Response(params?: ApiProductsqueryRecommendationsLatestGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<SalesArticleSummary>>> {
    return apiProductsqueryRecommendationsLatestGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProductsqueryRecommendationsLatestGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiProductsqueryRecommendationsLatestGet$Plain(params?: ApiProductsqueryRecommendationsLatestGet$Plain$Params, context?: HttpContext): Observable<Array<SalesArticleSummary>> {
    return this.apiProductsqueryRecommendationsLatestGet$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<SalesArticleSummary>>): Array<SalesArticleSummary> => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProductsqueryRecommendationsLatestGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiProductsqueryRecommendationsLatestGet$Response(params?: ApiProductsqueryRecommendationsLatestGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<SalesArticleSummary>>> {
    return apiProductsqueryRecommendationsLatestGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProductsqueryRecommendationsLatestGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiProductsqueryRecommendationsLatestGet(params?: ApiProductsqueryRecommendationsLatestGet$Params, context?: HttpContext): Observable<Array<SalesArticleSummary>> {
    return this.apiProductsqueryRecommendationsLatestGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<SalesArticleSummary>>): Array<SalesArticleSummary> => r.body)
    );
  }

  /** Path part for operation `apiProductsqueryRecommendationsLatestLabelGet()` */
  static readonly ApiProductsqueryRecommendationsLatestLabelGetPath = '/api/productsquery/recommendations/latest/{label}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProductsqueryRecommendationsLatestLabelGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiProductsqueryRecommendationsLatestLabelGet$Plain$Response(params: ApiProductsqueryRecommendationsLatestLabelGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<SalesArticleSummary>>> {
    return apiProductsqueryRecommendationsLatestLabelGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProductsqueryRecommendationsLatestLabelGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiProductsqueryRecommendationsLatestLabelGet$Plain(params: ApiProductsqueryRecommendationsLatestLabelGet$Plain$Params, context?: HttpContext): Observable<Array<SalesArticleSummary>> {
    return this.apiProductsqueryRecommendationsLatestLabelGet$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<SalesArticleSummary>>): Array<SalesArticleSummary> => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProductsqueryRecommendationsLatestLabelGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiProductsqueryRecommendationsLatestLabelGet$Response(params: ApiProductsqueryRecommendationsLatestLabelGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<SalesArticleSummary>>> {
    return apiProductsqueryRecommendationsLatestLabelGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProductsqueryRecommendationsLatestLabelGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiProductsqueryRecommendationsLatestLabelGet(params: ApiProductsqueryRecommendationsLatestLabelGet$Params, context?: HttpContext): Observable<Array<SalesArticleSummary>> {
    return this.apiProductsqueryRecommendationsLatestLabelGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<SalesArticleSummary>>): Array<SalesArticleSummary> => r.body)
    );
  }

  /** Path part for operation `apiProductsqueryRecommendationsRecommendUserIdGet()` */
  static readonly ApiProductsqueryRecommendationsRecommendUserIdGetPath = '/api/productsquery/recommendations/recommend/{userId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProductsqueryRecommendationsRecommendUserIdGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiProductsqueryRecommendationsRecommendUserIdGet$Plain$Response(params: ApiProductsqueryRecommendationsRecommendUserIdGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<SalesArticleSummary>>> {
    return apiProductsqueryRecommendationsRecommendUserIdGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProductsqueryRecommendationsRecommendUserIdGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiProductsqueryRecommendationsRecommendUserIdGet$Plain(params: ApiProductsqueryRecommendationsRecommendUserIdGet$Plain$Params, context?: HttpContext): Observable<Array<SalesArticleSummary>> {
    return this.apiProductsqueryRecommendationsRecommendUserIdGet$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<SalesArticleSummary>>): Array<SalesArticleSummary> => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProductsqueryRecommendationsRecommendUserIdGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiProductsqueryRecommendationsRecommendUserIdGet$Response(params: ApiProductsqueryRecommendationsRecommendUserIdGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<SalesArticleSummary>>> {
    return apiProductsqueryRecommendationsRecommendUserIdGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProductsqueryRecommendationsRecommendUserIdGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiProductsqueryRecommendationsRecommendUserIdGet(params: ApiProductsqueryRecommendationsRecommendUserIdGet$Params, context?: HttpContext): Observable<Array<SalesArticleSummary>> {
    return this.apiProductsqueryRecommendationsRecommendUserIdGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<SalesArticleSummary>>): Array<SalesArticleSummary> => r.body)
    );
  }

  /** Path part for operation `apiProductsqueryRecommendationsNeighborsItemIdGet()` */
  static readonly ApiProductsqueryRecommendationsNeighborsItemIdGetPath = '/api/productsquery/recommendations/neighbors/{itemId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProductsqueryRecommendationsNeighborsItemIdGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiProductsqueryRecommendationsNeighborsItemIdGet$Plain$Response(params: ApiProductsqueryRecommendationsNeighborsItemIdGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<SalesArticleSummary>>> {
    return apiProductsqueryRecommendationsNeighborsItemIdGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProductsqueryRecommendationsNeighborsItemIdGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiProductsqueryRecommendationsNeighborsItemIdGet$Plain(params: ApiProductsqueryRecommendationsNeighborsItemIdGet$Plain$Params, context?: HttpContext): Observable<Array<SalesArticleSummary>> {
    return this.apiProductsqueryRecommendationsNeighborsItemIdGet$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<SalesArticleSummary>>): Array<SalesArticleSummary> => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProductsqueryRecommendationsNeighborsItemIdGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiProductsqueryRecommendationsNeighborsItemIdGet$Response(params: ApiProductsqueryRecommendationsNeighborsItemIdGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<SalesArticleSummary>>> {
    return apiProductsqueryRecommendationsNeighborsItemIdGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProductsqueryRecommendationsNeighborsItemIdGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiProductsqueryRecommendationsNeighborsItemIdGet(params: ApiProductsqueryRecommendationsNeighborsItemIdGet$Params, context?: HttpContext): Observable<Array<SalesArticleSummary>> {
    return this.apiProductsqueryRecommendationsNeighborsItemIdGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<SalesArticleSummary>>): Array<SalesArticleSummary> => r.body)
    );
  }

}
